import {
    GetCurrenciesRequest,
    GetCurrenciesResponse,
    GetDeliveryTypesRequest,
    GetDeliveryTypesResponse,
    GetLocalesRequest,
    GetLocalesResponse,
    GetMeasurementUnitsRequest,
    GetMeasurementUnitsResponse,
    GetPaymentProvidersTypesRequest,
    GetPaymentProvidersTypesResponse,
    GetReportingDestinationTypesRequest, GetReportingDestinationTypesResponse
} from "./requestsResponses";
import { ConstantsApiMethods } from "./methods";
import { execute } from "../../apiCommandsExecutor";
import { ExecutionStatus } from "../general/requestsResponses";


export const getUnits = async () => {
    const response = await execute<GetMeasurementUnitsRequest, GetMeasurementUnitsResponse>(
        ConstantsApiMethods.getMeasurementUnits, {});
    return {
        err: !(response.status === 200 && response.data.executionStatus === ExecutionStatus.Finished),
        units: response.data.measurementUnits
    }
};


export const getLocales = async () => {
    const response = await execute<GetLocalesRequest, GetLocalesResponse>(
        ConstantsApiMethods.getLocales, {});

    return {
        err: !(response.status === 200 && response.data.executionStatus === ExecutionStatus.Finished),
        locales: response.data.locales
    }
};

export const getCurrencies = async () => {
    const response = await execute<GetCurrenciesRequest, GetCurrenciesResponse>(
        ConstantsApiMethods.getCurrencies, {});
    return {
        err: !(response.status === 200 && response.data.executionStatus === ExecutionStatus.Finished),
        currencies: response.data.currencies
    }
};



export const getDeliveryTypes = async () => {
    const response = await execute<GetDeliveryTypesRequest, GetDeliveryTypesResponse>(
        ConstantsApiMethods.getDeliveryTypes, {}
    );
    return {
        err: !(response.status === 200 && response.data.executionStatus === ExecutionStatus.Finished),
        currencies: response.data.deliveryTypes
    }
}

export const getPaymentProvidersTypes = async () => {
    const response = await execute<GetPaymentProvidersTypesRequest, GetPaymentProvidersTypesResponse>(
        ConstantsApiMethods.getPaymentProvidersTypes, {}
    );
    return {
        err: !(response.status === 200 && response.data.executionStatus === ExecutionStatus.Finished),
        currencies: response.data.paymentProvidersTypes
    }
}

export const getReportingDestinationTypes = async () => {
    const response = await execute<GetReportingDestinationTypesRequest, GetReportingDestinationTypesResponse>(
        ConstantsApiMethods.getPaymentProvidersTypes, {}
    );
    return {
        err: !(response.status === 200 && response.data.executionStatus === ExecutionStatus.Finished),
        currencies: response.data.reportingDestinationTypes
    }
}
